import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/account/api-keys')({
  beforeLoad: () => {
    throw redirect({ to: '/app/settings/agents', replace: true });
  },
});
